<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "pause" });
export let css = "";
export let isScaling = true;
</script>

<svg
    xmlns = 'http://www.w3.org/2000/svg'
    viewBox = '0 0 24 24'
    fill = 'none'
    on:mouseenter
    on:mouseleave
    on:keypress
    on:click
    class = { `s8-icon ${ css }` }
    stroke = '#272711'
>
    <path
        d = 'M10 4H5v16h5V4zm9 0h-5v16h5V4z'
        stroke-width = '1.2'
        stroke-linecap = 'round'
        stroke-linejoin = 'round'
        vector-effect = { isScaling ? 'none' : 'non-scaling-stroke' }
    />
</svg>